import React from 'react'
import File from '../../components/File'
import RichText from '../RichText'

const Files = ({entity: {fieldFiles, fieldBody}}) => {

  const body = fieldBody && <RichText body={fieldBody.processed} />

  const files = fieldFiles.map(fieldFile => {
    const mediaFile = fieldFile.entity.fieldMediaFile.entity
    const id = fieldFile.entity.entityId
    const fileName = mediaFile.filename
    const setName = fieldFile.entity.entityLabel ? fieldFile.entity.entityLabel : fileName

    const fileUrl = mediaFile.url
    const fileSize = mediaFile.filesize

    const ext = fileName.substr(fileName.lastIndexOf('.') + 1)

    return (<File name={setName} url={fileUrl} size={fileSize} ext={ext} key={id} />)
  });

  return (
    <div className="file-wrapper">
      <div className="intro-file">{body}</div>
      {files}
    </div>
  );

}

export default Files
